import React, { useRef, useState, useEffect } from 'react'
import { useRouter } from "../../../hooks/router";

import './RegisterSubUser.scss'

import Check from '../images/Check Icon.png'

import img_back from '../images/back-button.png'
import { create_sub_user, get_sub_images } from "../../../server/requests";
import { translateWord, decrypt } from "../../Util/util";

import ErrorMessage from "../../AlertMessage/ErrorMessage";

export default function RegisterSubUser() {
    const router = useRouter()
    const root = JSON.parse(decrypt('root', localStorage.getItem('root')))

    const [imagesArray, setImagesArray] = useState([
        { id: 0, img: '', active: true },
        { id: 1, img: '', active: false },
        { id: 2, img: '', active: false },
        { id: 3, img: '', active: false },
        { id: 4, img: '', active: false },
        { id: 5, img: '', active: false },
    ])

    const [checked, setChecked] = useState(false)
    const [formdata, setFormdata] = useState({
        username: '',
        pin: '',
        confirmPin: ''
    })
    const [errorMessage, setErrorMessage] = useState('')
    const [showErrorMessage, setShowErrorMessage] = useState(false)
    const [validateUserName, setValidateUserName] = useState(false)
    const [validatePin, setValidatePin] = useState(false)
    const [validateConfirmPin, setValidateConfirmPin] = useState(false)

    const refPinError = useRef()
    const refConfirmPinError = useRef()
    const refUserNameError = useRef()


    useEffect(() => {
        document.onkeyup = function () { }

        get_sub_images({}, res => {

            let _arr = []
            for (let i = 0; i < res.length; i++) {

                let obj = {
                    id: res[i].id,
                    img: res[i].url,
                    active: false
                }

                if (i == 0) obj.active = true

                _arr.push(obj)

            }

            setImagesArray(() => [..._arr])

        })

    }, []);

    const activeImgBtn = (e, i) => {
        const active_img = imagesArray.find(k => k.active === true)
        if (active_img !== undefined) active_img.active = false

        const newArray = [...imagesArray]
        newArray[i].active = true

        setImagesArray(newArray)
    }

    const changeValRegisterPin = (e) => {
        const { name, value } = e.target

        if (value.length < 5 && !isNaN(value)) {
            setFormdata(k => ({ ...k, [name]: value }))
        }
        if (name === 'pin') setValidatePin(false)
        else setValidateConfirmPin(false)
    }


    const hide_error_message = () => {
        setTimeout(() => {
            setShowErrorMessage(false)
        }, 3000)
    }

    const onSubmitRegister = (e) => {
        e.preventDefault()
        if (!formdata.username.length || !formdata.pin.length || !formdata.confirmPin.length) {
            if (!formdata.username.length) {
                setValidateUserName(true)
                refPinError.current.innerText = 'Please enter your Username'
            }
            if (!formdata.pin.length) {
                setValidatePin(true)
                refPinError.current.innerText = 'Please enter your PIN'
            }
            if (!formdata.confirmPin.length) {
                setValidateConfirmPin(true)
                refConfirmPinError.current.innerText = 'Please enter root password'
            }
        } else {
            if (formdata.username.length < 3) {
                setValidateUserName(true)
                refUserNameError.current.innerText = 'Username must be minimum of 3 characters'
            } else if (formdata.pin.length < 4) {
                setValidatePin(true)
                refPinError.current.innerText = 'PIN must be 4 characters'
            } else {
                const active_image = imagesArray.find(e => e.active === true)

                const body = {
                    password: formdata.pin,
                    age_restricted: checked ? 12 : 21,
                    name: formdata.username,
                    user_password: formdata.confirmPin,
                    image: active_image.img,
                }

                create_sub_user(body, res => {
                    router.push('/subusers')
                }, err => {
                    console.log(err)
                    setShowErrorMessage(true)
                    setErrorMessage(err)
                    hide_error_message()
                })
            }

        }
    }

    return (
        <React.Fragment>

            <ErrorMessage text={errorMessage} type={'error'} show={showErrorMessage} />
            <div className={'add_profile'}>
                <img className="back_to_sub_user" src={img_back} alt={''} onClick={() => router.push('/subusers')} />

                <h1 className="title_add_profile">{translateWord('add new profile', 'Add new profile')}</h1>
                <h4 className="title_list_images">{translateWord('select avatar for your new profile', 'Select avatar for your new profile')}:</h4>

                <div className="list_images_add_profile">
                    {imagesArray.map((e, i) => {
                        return <img key={e.id} src={window._HOST_ + '/' + e.img} style={e.active ? { boxShadow: '0 0 0 .3rem white' } : null} alt=""
                            onClick={() => activeImgBtn(e, i)} />
                    })}
                </div>

                <div className="register_field">
                    <form action="">
                        <div className="inputs_field">
                            <div className={validateUserName ? "profile_name_reg show" : "profile_name_reg"}>
                                <label htmlFor="">{translateWord('profile name', 'Profile Name')}:</label>
                                <input
                                    type="text"
                                    name={'username'}
                                    value={formdata.username}
                                    onChange={(e) => {
                                        setFormdata(k => ({ ...k, username: e.target.value }))
                                        setValidateUserName(false)
                                    }}
                                />
                                <span className="error_text" ref={refUserNameError}>{translateWord('Please enter your Username', 'Please enter your Username')}</span>
                            </div>
                            <div className={validatePin ? "profile_Pin_reg show" : "profile_Pin_reg"}>
                                <label htmlFor="">
                                    {translateWord('profile pin', 'Profile PIN')}:
                                    <span>{translateWord('leave blank if you don\'t want pin', 'Leave blank if you don\'t want PIN')}</span>
                                </label>
                                <input type="password" name={'pin'} value={formdata.pin} onChange={changeValRegisterPin} />
                                <span className="error_text" ref={refPinError}>{translateWord('Please enter your PIN', 'Please enter your PIN')}</span>
                            </div>
                            <div className={validateConfirmPin ? "profile_Pin_reg show" : "profile_Pin_reg"}>
                                <label htmlFor="">{translateWord('Root password', 'Root password')}</label>
                                <input type="password" name={'confirmPin'} value={formdata.confirmPin}
                                    onChange={changeValRegisterPin} />
                                <span className="error_text" ref={refConfirmPinError}>{translateWord('Please confirm your PIN')}</span>
                            </div>
                        </div>
                        <div className="kids_profile">
                            <div className="checked_reg" onClick={() => setChecked(!checked)}>
                                {checked ? <img src={Check} alt="" /> : null}
                            </div>
                            <div className="title_kids_reg">
                                <h3>{translateWord('Kids Profile')}</h3>
                                <p>{translateWord('If checked, only contents for kids 12 and under available')}</p>
                            </div>
                        </div>
                        <div className="buttons_register ">
                            <button onClick={onSubmitRegister} className={'card_color'}>{translateWord('Add Profile')}</button>
                            <button className={'card_color'} onClick={() => router.push('/subusers')}>{translateWord('Cancel')}</button>
                        </div>
                    </form>
                </div>

            </div>
        </React.Fragment>

    )
}